import { useEffect, useState } from "react";
import { Cascader } from "antd";

import SearchInBoard from "../SearchInBoard";
import { BoardType } from "../../type";

import styles from "../../style/index.module.scss";

const Board = ({
  options,
  value,
  searchBoardPlaceholder,
  visibleSearch = true,
  searchValue,
  setSearchValue,
  setSelectValue,
  selectValue,
  onMultipleChange,
  cascaderPanelProps,
  cascaderStyles,
  onlySearchInLastedLayer,
  renderSearchEmpty
}: BoardType) => {
  return (
    <div style={{ padding: 12, position: "relative", height: "100%" }}>
      {visibleSearch && (
        <>
          <SearchInBoard
            options={options}
            renderSearchEmpty={renderSearchEmpty}
            setValue={setSelectValue}
            searchBoardPlaceholder={searchBoardPlaceholder}
            searchValue={searchValue}
            onChange={onMultipleChange}
            value={value}
            setSearchValue={setSearchValue}
            onlySearchInLastedLayer={onlySearchInLastedLayer}
          />
          <div style={{ height: 14 }} />
        </>
      )}

      <Cascader.Panel
        multiple={false}
        options={options}
        style={cascaderStyles}
        value={selectValue}
        onChange={onMultipleChange}
        // showCheckedStrategy='SHOW_CHILD'
        className={styles.overridePanel}
        expandTrigger='hover'
        {...cascaderPanelProps}
      />
    </div>
  );
};

export default Board;
